import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "tooltip__body" };
const _hoisted_2 = { class: "text text--sm" };
import { onMounted, onUnmounted, ref } from "vue";
import { Tooltip } from "./tooltips";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Tooltip',
    props: {
        button: { type: Object },
    },
    setup(__props) {
        const props = __props;
        const tooltipElement = ref();
        let tooltip = null;
        function init() {
            tooltip = new Tooltip(props.button, tooltipElement.value);
            tooltip.attachClickEvents();
        }
        onMounted(() => {
            if (props.button && tooltipElement.value) {
                init();
            }
            else {
                setTimeout(init, 1);
            }
        });
        onUnmounted(() => {
            if (tooltip) {
                tooltip.destroy();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "tooltip",
                role: "tooltip",
                ref_key: "tooltipElement",
                ref: tooltipElement
            }, [
                _cache[0] || (_cache[0] = _createElementVNode("span", {
                    class: "tooltip__arrow",
                    "data-arrow": ""
                }, null, -1 /* HOISTED */)),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ])
            ], 512 /* NEED_PATCH */));
        };
    }
});
